import React, { Component } from 'react';
import SingleLineCaption from '../dom-elements/SingleLineCaption';
import Image from './../dom-elements/Image';
import { bgImage } from './../../scripts';


export default class GridItemMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickCount: 0,
      showIcon: false
    };
    this.clickCounter = this.clickCounter.bind(this);
  }

  clickCounter(id){
    var t = this;
    if (this.state.clickCount == 0) {
      t.setState({
        clickCount: 1,
        showIcon: true
      });
    } else if (this.state.clickCount == 1) {
      t.setState({
        clickCount: 0,
        showIcon: false
      });
      this.props.clickFunction(id);
    }
  }

  render() {
    return (
      <div className={'flexible-image-wrapper'} onClick={() => { this.clickCounter(this.props.ImgData.urls.id); }}>
        <div className={'image-inner'}>
          <div className={(this.state.showIcon) ? 'enlarge active' : 'enlarge'}>
            <div className={'expand-icon'} style={bgImage('/static/icons/expand.svg')} />
          </div>
          <Image source={this.props.ImgData.urls.small} />
        </div>
        <SingleLineCaption Headline={this.props.ImgData.metadata.title} Description={this.props.ImgData.metadata.caption} Stacked={true} />
        <style jsx>{`
          .enlarge {
            transition: opacity 250ms ease;
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            padding: 1.5rem;
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
            opacity: 0;
          }
          .enlarge.active {
            opacity: 1;
          }
          .expand-icon {
            height: 2rem;
            width: 2rem;
          }
        `}</style>
      </div>
    );
  };
};



// WEBPACK FOOTER //
// ./src/components/photo-film-project/GridItemMobile.js